<template>
  <div class="container">
    <HeadingOne class="-margin-md">収入証明書のご提出</HeadingOne>

    <WizardGroup class="_mb-sm-35 _mb-md-50">
      <MainWizard :active-index="3" type="income"></MainWizard>
    </WizardGroup>

    <StepPage class="-success">
      <StepHeader>
        <img
          src="@/assets/images/icons/check-ok.svg"
          class="_i-w-sm-37 _i-w-md-74 _mb-sm-15 _mb-md-30"
          alt=""
        />
        <h2 class="heading">
          収入証明書のアップロードが完了しました。<br />ありがとうございました。
        </h2>
      </StepHeader>
    </StepPage>
    <BtngroupSingle class="-margin-lg">
      <BtnMain class="-normal" router-name="mb001">
        会員さま専用サイトトップへ
      </BtnMain>
    </BtngroupSingle>
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import HeadingOne from "@/components/heading/HeadingOne";
import MainWizard from "@/components/wizard/MainWizard";
import WizardGroup from "@/components/wizard/WizardGroup";
import BtnMain from "@/components/button/BtnMain";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import StepPage from "@/components/steps/StepPage";
import StepHeader from "@/components/steps/StepHeader";

export default {
  name: "Tem026",
  components: {
    StepHeader,
    StepPage,
    BtnMain,
    BtngroupSingle,
    WizardGroup,
    MainWizard,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "収入証明書のご提出",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,収入証明書",
    });
  },
  data() {
    return {
      state: this.$route.query.state,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.steps-box {
  padding: 20px;
  @include mq-down(md) {
    margin-right: -20px;
    margin-left: -20px;
  }
  @include mq-up(md) {
    border-radius: 10px;
  }
  &.-success {
    background-color: $success;
  }
  > .steps-header {
    text-align: center;
    padding: 30px 0px 30px;
    @include mq-up(md) {
      padding: 40px 20px 60px;
    }
    .heading {
      color: $primary;
      font-weight: bold;
      font-size: 20px;
      @include mq-up(md) {
        font-size: 32px;
      }
    }
  }
  > .steps-body {
    background-color: $white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 2px 2px rgba($secondary, 0.6);
    @include mq-up(md) {
      border-radius: 10px;
      padding: 40px;
    }
  }
}
</style>
